







  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"SessionHistory"
})
export default class Profil extends Vue {}
